import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemBrassBell extends Item {
    constructor() {
        super(definitions.ITEM_ID.BRASS_BELL, texture("prop_bell_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(0, 0));
    }
}